import {configureStore} from "@reduxjs/toolkit";
import rootReducer from './reducer/rootReducer';

export const store = configureStore({
    reducer: rootReducer
});

export const dispatch = store.dispatch;

// todo delete debug only
window.store = store;